import script from "./StatsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./StatsHeader.vue?vue&type=style&index=0&id=763af23b&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763af23b"]])

export default __exports__